import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-state-inactive-popup',
  templateUrl: './state-inactive-popup.component.html',
  styleUrls: ['./state-inactive-popup.component.scss'],
})
export class StateInactivePopupComponent {
  stateName: string = '';

  constructor(
    public dialogRef: MatDialogRef<StateInactivePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { stateName: string }
  ) {
    this.stateName = data?.stateName || '';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
